import template from './wageAdvanceList.html';
import './wageAdvanceList.scss';

let wageAdvanceListComponent = {
  restrict: 'E',
  bindings: {
    employeeWagesAdvance: '<',
    onCancel: '&',
    isMobileApp: '<'
  },
  template
};

export default wageAdvanceListComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceList.component.js